<script>
import { counterMixin } from '@mixins/counter-mixin';
import { authComputed } from '@src/state/helpers';

export default {
  components: {},
  props: {
    recipe: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  mixins: [counterMixin],
  data() {
    return {
      placeholder: require('@assets/images/placeholder-photo-upload.svg'),
    };
  },
  computed: {
    ...authComputed,
    prepTime() {
      return this.$_formatPrepTime(this.recipe.preparetime);
    },
    coverPhoto() {
      return (
        (this.recipe && this.recipe.imageURL) ||
        (this.recipe && this.recipe.imageurl) ||
        (this.recipe && this.recipe.imageUrl) ||
        this.placeholder
      );
    },
    orgName() {
      return (
        this.currentUser && this.currentUser.org && this.currentUser.org.name
      );
    },
  },
};
</script>

<template>
  <div class="hero-recipe-minimal">
    <div
      class="hero-image-wrapper"
      :style="[{ 'background-image': `url(${coverPhoto})` }]"
    >
      <span class="tags-wrapper" v-if="recipe.preparetime">
        <div class="meta-tag">
          <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-stopwatch'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 0h6v2H6V0zm2 13V7h2v6H8zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42A8.962 8.962 0 009 3a9 9 0 00-9 9c0 4.97 4.02 9 9 9a8.994 8.994 0 007.03-14.61zM2 12c0 3.87 3.13 7 7 7s7-3.13 7-7-3.13-7-7-7-7 3.13-7 7z" fill="#000"/></svg>
          {{ prepTime }}
        </div>
      </span>
    </div>
    <div class="hero-title-wrapper">
      <h2>
        <span v-if="recipe.useLeftovers">Leftover</span> {{ recipe.title }}
      </h2>
      <span class="hero-org-name" v-if="orgName"> by {{ orgName }} </span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.hero-recipe-minimal {
  margin-bottom: 3.5rem;

  .hero-image-wrapper {
    align-items: flex-start;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: $base-border-radius-lg;
    display: flex;
    height: 39rem;
    justify-content: space-between;
    padding: 1.6rem;
    width: 100%;

    .hero-org-name {
      font-size: 1.8rem;
      font-weight: normal;
      letter-spacing: -0.761905px;
      line-height: 5.2rem;
    }

    .tags-wrapper {
      display: flex;
      justify-content: space-between;
      width: 100%;

      .meta-tag {
        background-color: rgba($color-black-wo-rgb, 0.5);
        border-radius: $base-border-radius;
        color: white;
        font-size: 1.2rem;
        font-weight: 800;
        letter-spacing: 0.1px;
        line-height: 2.2rem;
        padding: 0.5rem 1rem;
        text-transform: uppercase;
      }
    }

    .icon-stopwatch {
      margin-right: 0.5rem;
      width: 1.4rem;

      path {
        fill: white;
      }
    }
  }

  .hero-title-wrapper {
    padding-top: 3rem;
  }
}
</style>
